import React from 'react';
import Header from "../lib/Header";
import Input from "./Input";
import Preview from "./Preview";
import GoldColorSelector from "../lib/GoldColorSelector";
import OrientationSelector from "./OrientationSelector";
import LengthSelector from "./LengthSelector";
import ChainSelector from "../lib/ChainSelector";

export default class App extends React.Component {
    render() {
        return (
            <div className="product__options customizer">
                <div className="customizer__heroine">
                    <Preview/>
                    <Input/>
                </div>
                <div>
                    <Header text='Custom Letter Necklace'/>
                    <OrientationSelector/>
                    <GoldColorSelector/>
                    <ChainSelector/>
                    <LengthSelector/>
                </div>
            </div>
        );
    }
}
